// extracted by mini-css-extract-plugin
export default {"learnMoreCard":"LearnMoreStyle_learnMoreCard__w3TUL","subText":"LearnMoreStyle_subText__W0Qaz","btn":"LearnMoreStyle_btn__c5ZJz"};